import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyEmail } from 'store/auth';
import { Spinner } from 'react-bootstrap';

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const verifyUserEmail = async () => {
      const token = searchParams.get('token');
      const user_id = searchParams.get('user_id');
      const email = searchParams.get('email');

      // Validate required parameters
      if (!token || !user_id) {
        setStatus('error');
        setMessage('Invalid verification link. Please check your email and try again.');
        return;
      }

      try {
        // Call the verification API
        const response = await verifyEmail(user_id, email, token);
        
        setStatus('success');
        setMessage(response.data?.message || 'Email verified successfully! You can now sign in.');
        
        // Start countdown for redirect
        let counter = 5;
        const timer = setInterval(() => {
          counter -= 1;
          setCountdown(counter);
          
          if (counter === 0) {
            clearInterval(timer);
            navigate('/'); // Redirect to home/login page
          }
        }, 1000);

        return () => clearInterval(timer);
        
      } catch (error) {
        setStatus('error');
        setMessage(error.message || 'Verification failed. The link may be invalid or expired.');
      }
    };

    verifyUserEmail();
  }, [searchParams, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '500px',
        width: '100%',
        background: '#ffffff',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        textAlign: 'center'
      }}>
        {status === 'verifying' && (
          <>
            <Spinner animation="border" variant="primary" style={{ width: '60px', height: '60px', marginBottom: '20px' }} />
            <h2 style={{ color: '#333', marginBottom: '15px' }}>Verifying Your Email</h2>
            <p style={{ color: '#666', fontSize: '16px' }}>
              Please wait while we verify your email address...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{
              width: '80px',
              height: '80px',
              margin: '0 auto 20px',
              background: '#10b981',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <h2 style={{ color: '#10b981', marginBottom: '15px' }}>Email Verified!</h2>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>
              {message}
            </p>
            <p style={{ color: '#666', fontSize: '14px' }}>
              Redirecting to login in <strong>{countdown}</strong> seconds...
            </p>
            <button
              onClick={() => navigate('/')}
              style={{
                marginTop: '20px',
                padding: '12px 30px',
                background: '#3f51b5',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Go to Login Now
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{
              width: '80px',
              height: '80px',
              margin: '0 auto 20px',
              background: '#ef4444',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>
            <h2 style={{ color: '#ef4444', marginBottom: '15px' }}>Verification Failed</h2>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>
              {message}
            </p>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '20px' }}>
              Please try signing up again or contact support if the problem persists.
            </p>
            <button
              onClick={() => navigate('/')}
              style={{
                padding: '12px 30px',
                background: '#3f51b5',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Back to Home
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;